import React from 'react';
import useCioBreadcrumb from '../../hooks/useCioBreadcrumb';
import { splitBreadcrumbs } from './utils';
import BreadcrumbElement from './BreadcrumbElement';
import MoreBreadcrumbsMenu from './MoreBreadcrumbsMenu';
export default function Breadcrumbs(props) {
    const { breadcrumbs = [], currentPage, onBreadcrumbClick } = useCioBreadcrumb(props);
    if (!currentPage && (!breadcrumbs || breadcrumbs.length === 0))
        return null;
    const { firstItems, middle, lastItems } = splitBreadcrumbs(breadcrumbs);
    return (React.createElement("nav", { "aria-label": 'plp-breadcrumbs' },
        React.createElement("ul", { className: 'cio-breadcrumbs-container' },
            firstItems.map((breadcrumb) => (React.createElement(BreadcrumbElement, { key: breadcrumb.path, ...breadcrumb, onClick: onBreadcrumbClick }))),
            middle.length > 0 && React.createElement(MoreBreadcrumbsMenu, { breadcrumbs: middle }),
            lastItems.map((breadcrumb) => (React.createElement(BreadcrumbElement, { key: breadcrumb.path, ...breadcrumb, onClick: onBreadcrumbClick }))),
            React.createElement(BreadcrumbElement, { breadcrumb: currentPage, isCurrentPage: true }))));
}
